export default {
  userInfo: {},
  shouldChangePassword: false,
  promoterAccesses: [],
};
